import { memo, useEffect, useState, createRef } from 'react';
import { View, StyleSheet, Text, Image } from 'react-native';
import { I18n, Utils, FormInput, AddButton, Panel, Select, Navigation } from '../../components';
import { THEME, __WEB__, COLOR, FONT, SELECT_STYLE_ROUND } from '../../../constants/styles';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getCurrentEmployer } from '../../../selectors/entities';
import VALocations from './va_locations';
import { addMedRecruiterClinicalLocation, resetStatus } from '../../employer/actions';
import { vaRegionNameAndCount } from '../../employer/selector';

export default memo(
  connect(
    function (state, ownProps) {
      const employer = getCurrentEmployer(state);

      const regions = vaRegionNameAndCount(state);
      const options = regions.map((r) => ({ label: r.name, value: r.id }));
      return {
        employer,
        regions: regions,
        options: options,
        saveSetupDataStatus: state.screens.employer.saveSetupDataStatus,
      };
    },
    function (dispatch) {
      return {
        actions: bindActionCreators({ addMedRecruiterClinicalLocation, resetStatus }, dispatch),
      };
    }
  )(function (props) {
    const selected = props.options[0] || null;
    const [selectedRegion, setSelectedRegion] = useState(selected);

    function handleAddPress() {
      Navigation.showModal({
        screen: 'VALocationsForm',
        title: `Add VA Location`,
        passProps: {
          onSave: handleSave,
          title: `Add VA Location`,
          selectedRegion: selectedRegion?.value,
        },
      });
      props.actions.resetStatus();
    }

    function handleSave(location) {
      const body = {
        vaRegionsAndNames: [{ va_region: location.vaRegion, name: location.vaLocation }],
      };
      props.actions.addMedRecruiterClinicalLocation(props.employer.employerId, body);
      setSelectedRegion(props.options.find((i) => i.value === location.vaRegion));
    }

    function handleSelect(value) {
      setSelectedRegion(value);
    }

    function renderAddButton() {
      if (!props.canEdit) return null;
      return (
        <AddButton
          label="ADD"
          onPress={handleAddPress}
          containerStyle={{ height: 40, paddingRight: 10, marginLeft: 10 }}
        />
      );
    }

    const selectedItem = selectedRegion && props.regions.find((i) => i.id === selectedRegion.value);
    return (
      <Panel
        title={'VA Locations'}
        collapsable={props.collapsable}
        containerStyle={props.containerStyle}
        extraHeaderContent={renderAddButton()}
      >
        <View style={{ height: __WEB__ ? 300 : 'auto' }}>
          <View style={styles.locationContainer}>
            <View style={styles.selectContainer}>
              <View style={{ paddingLeft: __WEB__ ? 0 : 10 }}>
                <Select
                  onValue={handleSelect}
                  required={false}
                  closeOnSelect={true}
                  options={props.options}
                  label={null}
                  value={selectedRegion}
                  webMode={true}
                  isClearable={false}
                  containerStyle={{ marginVertical: 0 }}
                  noLabel={true}
                  styles={SELECT_STYLE_ROUND}
                  valueStyle={{ ...FONT.regular, fontSize: 14, color: 'rgb(60, 60, 60)' }}
                />
              </View>
            </View>
            <View style={styles.buttonsContainer}>
              <View style={[THEME.basicRow, { flexGrow: 1, paddingLeft: 30 }]}>
                <Image
                  style={{ width: 13, height: 14 }}
                  source={require('../../../../resources/staff-icon-small.png')}
                />
                <Text style={[THEME.textBold, { fontSize: 10, paddingLeft: 6 }]}>
                  {selectedItem?.count}
                </Text>
              </View>
            </View>
          </View>
          <VALocations
            selectedRegionId={selectedRegion?.value}
            selectedRegionName={selectedRegion?.label}
            onConfirmationOpts={props.onConfirmationOpts}
          />
        </View>
      </Panel>
    );
  })
);

const styles = StyleSheet.create({
  locationContainer: {
    ...THEME.basicRow,
    borderBottomWidth: 2,
    borderColor: COLOR.accent,
    zIndex: 1000,
    padding: 10,
  },
  selectContainer: {
    flex: 0.75,
  },
  buttonsContainer: {
    ...THEME.basicRow,
    ...THEME.rowButtons,
    flex: 0.5,
    justifyContent: 'flex-end',
  },
  input: {
    ...THEME.input,
    height: 30,
    borderWidth: 1,
    borderColor: COLOR.accent,
    backgroundColor: COLOR.contrast,
    fontSize: __WEB__ ? 12 : 12,
  },
  sectionHeaderColumn: {
    ...THEME.sectionHeaderColumn,
    paddingVertical: 10,
  },
});
